import { useQueryCache } from 'query';

import { grids } from './queryKeyFactory';

export const useIsFetching = () => {
  const { isFetching }: any = useQueryCache(grids, {
    exact: false,
  });

  return isFetching;
};
